import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { PLAN, RESPONSIVE_SIZE } from '../../constants';
import { showSignup } from '../../actions/user';
import { setChosenPlan, getPlanPrice } from '../../actions/plan';
import Button from '../Button';
import Link from '../Link';
import Style from '../Style';
import { H4, H6, L3 } from '../Typography';

class PricingStrip extends React.PureComponent {
  static propTypes = {
    responsive: PropTypes.number,
    showSignup: PropTypes.func,
    to: PropTypes.string,
    onClick: PropTypes.func,
    plan: PropTypes.string,
    annual: PropTypes.bool,
  };
  static defaultProps = {
    plan: PLAN.UNLIMITED,
    annual: true,
  };

  doOnClick = e => {
    if (this.props.onClick) {
      this.props.onClick(e);
    } else {
      this.props.showSignup(this.props.plan, this.props.annual);
    }
  };

  render() {
    const {
      responsive,
      showSignup,
      to,
      onClick,
      plan,
      annual,
      ...otherProps
    } = this.props;

    const stacked = responsive < RESPONSIVE_SIZE.TABLET_PORTRAIT;

    return (
      <div
        style={{
          backgroundColor: Style.Colors.shadow5,
        }}
      >
        <div
          style={{
            maxWidth: '80rem',
            margin: 'auto',
            padding: '2rem',
            minHeight: '15rem',
            display: 'flex',
            flexDirection: stacked ? 'column' : 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
          }}
        >
          <div
            style={{
              margin: '2rem 0',
              flexBasis: '50%',
              width: '50%',
              minWidth: '30rem',
            }}
          >
            <H6>
              Unlimited&nbsp;licenses.<br />500+&nbsp;New&nbsp;Clips
              Every&nbsp;Month.
            </H6>
            <L3>NO DOWNLOAD LIMIT&nbsp;&nbsp;•&nbsp;&nbsp;1080p + 4K ProRes</L3>
          </div>
          <div
            style={{
              margin: '2rem 0',
              flexBasis: '50%',
              width: '50%',
              minWidth: '30rem',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
            }}
          >
            <H4 style={{ margin: '0 2rem' }}>
              ${getPlanPrice(plan, annual)}/mo.
            </H4>
            <Link to={to} onClick={this.doOnClick}>
              <Button size="large">Get&nbsp;Started</Button>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    responsive: state.runtime.responsive,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    showSignup: (plan, annual) => {
      dispatch(setChosenPlan({ name: plan, annual: annual }));
      dispatch(showSignup());
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PricingStrip);



// WEBPACK FOOTER //
// ./src/components/PricingStrip/PricingStrip.js